import type { ReactElement } from "react"

export interface PayrollLateResultNoticeProps {
  status: "loading" | "ready" | "empty" | "error" | "denied"
  originalPostingDate?: string
  adjustmentPostingDate?: string
  onRetry: () => void
}

export function PayrollLateResultNotice({
  status,
  originalPostingDate,
  adjustmentPostingDate,
  onRetry,
}: PayrollLateResultNoticeProps): ReactElement {
  if (status === "loading") return <p aria-live="polite">Loading payroll period treatment…</p>
  if (status === "denied") return <p role="alert">You do not have access to payroll accounting.</p>
  if (status === "error") return (
    <div role="alert">
      <p>Payroll period treatment is temporarily unavailable.</p>
      <button type="button" onClick={onRetry}>Try again</button>
    </div>
  )
  if (status === "empty") return <p>No late payroll adjustments require review.</p>
  return (
    <section aria-labelledby="payroll-late-result-title">
      <h2 id="payroll-late-result-title">Late payroll result</h2>
      <p>
        Original event date: <time dateTime={originalPostingDate}>{originalPostingDate}</time>.
        The balanced adjustment posts on{" "}
        <time dateTime={adjustmentPostingDate}>{adjustmentPostingDate}</time>.
      </p>
      <p role="note">
        The original accounting period remains closed. ImpetusOS never reopens it automatically.
      </p>
    </section>
  )
}
